<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between">
            <div class="page-title line-height">活动会议</div>
            <el-link :href="toActiveity" :underline="false" target="_blank">
                <el-button class="blue-btn" round>发布活动</el-button>
            </el-link>
        </div>
        <div class="flex align-center margin-top-sm">
            <el-select v-model="status" clearable placeholder="请选择状态">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="进行中" :value="1"></el-option>
                <el-option label="已结束" :value="2"></el-option>
            </el-select>
            <el-select v-model="type" class="margin-lr-sm" clearable placeholder="请选择类型">
                <el-option label="全部" :value="0"></el-option>
                <el-option label="线下" :value="1"></el-option>
                <el-option label="线上" :value="2"></el-option>
            </el-select>
            <el-button round type="primary" @click="search">搜索</el-button>
        </div>
        <div class="flex flex-direction">
            <a v-for="(item,index) in lists" :key="index" :href="`${web_yhb_detail}${item.id}&code=${user.emofUserTokenSafer}`"
               class="item-notice flex align-center"
               target="_blank">
                <img v-if="item.xianshangxianxia === 1" class="tag" src="../../../../assets/img/xianxia.png"/>
                <img v-else class="tag" src="../../../../assets/img/xianshang.png"/>
                <el-image :src="item.haibao" class="image"></el-image>
                <div class="flex flex-direction justify-between margin-left-sm flex-sub overflow-hidden">
                    <div class="flex align-center margin-bottom-xs">
                        <span v-if="item.kindname" class="classify flex-shrink">{{ item.kindname }}</span>
                        <div class="title ovHide">
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="time">时间：{{ item.starttime }} - {{ item.endtime }}</div>
                    <div class="time">主办方：{{ item.holdhost }}</div>
<!--                    <div class="time">-->
<!--                        地点：{{ item.sheng === item.shi ? item.shi : item.sheng }}{{-->
<!--                            item.shi === '直辖市' ? '' : item.shi ===-->
<!--                            item.sheng ? "" : item.shi-->
<!--                        }}{{ item.qu }}{{ item.address }}-->
<!--                    </div>-->
                </div>
                <div class="flex flex-direction align-center">
                    <div class="apply-total"><span>{{ item.user_num }}</span>人已报名</div>
                    <el-button :disabled="item.state !== 1" class="to-apply">{{ item.state | state }}</el-button>
                </div>
            </a>
        </div>
        <empty v-if="lists.length === 0" :type="0"/>
        <el-pagination
            v-if="lists.length>0"
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all margin-top"
            layout="prev, pager, next, jumper"
            @current-change="init">
        </el-pagination>
    </div>
</template>

<script>
import {YHB_URL} from '@/config/index'
import {getMeetings} from '@/api/organiz'
// import {zhDate} from '@/utils/utils'
import {web_yhb, web_yhb_detail} from "@/utils/const";

export default {
    name: "metting",
    data() {
        return {
            status:'',
            type:'',
            web_yhb_detail: web_yhb_detail,
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            toActiveity: ''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [5, 2], '机构活动')
        this.toActiveity = `${web_yhb}tiaoz?code=` + this.user.emofUserTokenSafer
        this.init()
    },
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getMeetings(this.status,this.type,this.page, this.limit)
            if (_data.status === 200) {
                _data.data.map(item => {
                    item.haibao = YHB_URL + item.haibao
                    // item.starttime = zhDate(item.starttime * 1000, 2)
                    // item.endtime = zhDate(item.endtime * 1000, 2)
                })
                this.lists = _data.data
            }else {
                this.lists = [];
            }
        },
        search() {
            this.page = 1
            this.init()
        }
    },
    filters: {
        state(type) {
            switch (Number(type)) {
                case 0:
                    return '未开始'
                case 1:
                    return '报名中'
                default:
                    return '已结束'
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .item-notice {
        width: 100%;
        min-height: 109px;
        background-color: #f3f7fb;
        border-radius: 10px;
        margin-top: 20px;
        padding: 11px 20px;
        position: relative;

        .tag {
            position: absolute;
            top: 0;
            right: 0;
        }

        .image {
            width: 116px;
            height: 88px;
            border-radius: 10px;
        }

        .title {
            font-size: 20px;
            font-weight: bold;
            color: #0a2240;
        }

        .classify {
            background-color: #ff9600;
            border-radius: 9px;
            padding: 3px 6px;
            font-size: 14px;
            color: #fefeff;
            margin-right: 6px;
        }

        .read {
            width: 39px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            background-color: #ff9600;
            border-radius: 8px;
            font-size: 12px;
            margin-right: 8px;
            color: #ffffff;

            .ed {
                background-color: #8ba2c6;
            }
        }

        .time {
            font-size: 14px;
            color: #7889a4;
            margin-right: 8px;
            margin-top: 3px;

            &.yellow {
                color: #ff9600;
            }
        }

        .apply-total {
            font-size: 14px;
            color: #0a2240;
            font-weight: bold;

            span {
                font-weight: normal;
                color: #fea423;
            }
        }

        .to-apply {
            min-width: 99px;
            height: 40px;
            border-radius: 20px;
            font-size: 16px;
            margin-top: 6px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            color: #ffffff;

            &.white {
                background: #ffffff none;
                color: #ff9600;
            }

            &:disabled {
                background: #b4c7e5 none;
            }
        }
    }
}

</style>